import {  SxProps, TableCell, TableHead, TableRow } from '@mui/material'
import { reaction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FixedSizeList, ListChildComponentProps } from 'react-window'
import useResizeObserver from 'use-resize-observer'
import { useMainStore } from '../../imacros-generator/store'
import appStore from '../../store'
import Row from './row'
import TableStore from './store'
import { Container, Table } from './styled'
import { getCellStyle } from './utils'

type Column = {
  title?: string,
  size?: number | string,
  editable?: boolean
}

type RichTableProps = {
  sx?: SxProps
}

const RichTable = observer(({ sx }: RichTableProps) => {

  const [ store ] = useState(() => new TableStore())
  const mainStore = useMainStore()
  const tableRef = useRef<HTMLDivElement>(null)

  const columns: { [ key: string ]: Column } = {
    id: { title: mainStore.scheme.blockKeyTitle, size: '100px', editable: false },
    ...mainStore.scheme.tableColumns
  }

  const { ref, height } = useResizeObserver()
  const rowHeight = 52
  const headerHeight = 56
  const h = (height || headerHeight) - headerHeight

  useEffect(() => reaction(() => store.selectedCell, () => {
    requestAnimationFrame(() => {
      const table = tableRef.current
      if (!table) return
      table.querySelector<HTMLInputElement>("#table-input")?.select()
    })
  }), [ ])

  const renderRow = useCallback(({ style, index }: ListChildComponentProps) => {
    return (
      <Row style={style} index={index} columns={columns} store={store}/>
    )
  }, [ appStore.currentScheme ])

  return (
    <Container ref={ref} sx={sx}>
      <Table sx={{ ".MuiTableCell-root": { height: rowHeight } }} ref={tableRef}>
        <TableHead component="div" sx={{ flexShrink: 0 }}>
          <TableRow component="div" sx={{ pr: mainStore.arrayValues.length * rowHeight > h? '10px': 0 }}>
            { Object.keys(columns).map((key) => (
              <TableCell component="div" style={getCellStyle(columns[key].size)} key={key}>
                {columns[key].title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <FixedSizeList className='list' width="100%" height={h} itemSize={rowHeight} itemCount={mainStore.arrayValues.length}>
          { renderRow }
        </FixedSizeList>
      </Table>
    </Container>
  )
})

export default RichTable